export class VesselDocument {
}
